module.exports = __webpack_public_path__ + "img/chevron-left.6d7627e9.svg";